import styled from "styled-components";

export const SwitchContainer = styled.div`
	display: flex;
	align-items: center;

	.switch {
		position: relative;
		display: inline-block;
		width: 80px;
		height: 40px;
		border-radius: 60px;
	}

	.switch-input {
		opacity: 0;
		position: absolute;
	}

	.switch-label {
		position: absolute;
		top: 5px;
		left: 5px;
		right: 5px;
		bottom: 5px;
		background-color: #28cc75;
		box-shadow: inset 0 3px 1px 1px rgba(0, 0, 0, 0.1);
		transition: all 0.2s ease;
		border-radius: inherit;
	}

	.switch-label::before {
		/* content: attr(data-smoke); */
		content: url(${require("@/assets/img/check.png").default});
		position: absolute;
		font-family: sans-serif;
		font-weight: bold;
		z-index: 100;
		top: 50%;
		right: 0.8rem;
		height: 10px;

		transform: translateY(-50%);
		color: white;
		font-size: 0.8rem;
		transition: all 0.1s ease;
		color: white;
		text-shadow: 0 -2px 0 rgba(0, 0, 0, 0.2);
	}

	.switch-label::after {
		/* content: attr(data-nosmoke); */
		content: url(${require("@/assets/img/close.png").default});
		position: absolute;
		font-family: sans-serif;
		font-weight: bold;
		display: inline-block;
		height: 15px;

		z-index: 100;
		top: 50%;

		left: -0.8rem;
		transform: translateY(-50%);
		color: white;
		font-size: 0.8rem;
		transition: all 0.1s ease;
		color: white;
		text-shadow: 0 -2px 0 rgba(0, 0, 0, 0.2);
		opacity: 0;
	}

	.slider {
		position: absolute;
		top: 6px;
		left: 6px;
		bottom: 6px;
		width: 30px;
		background: linear-gradient(to bottom, white, #cccccc);
		z-index: 10000;
		box-shadow: 0 3px 14px 2px rgba(0, 0, 0, 0.3);
		transition: all 0.2s ease;
		border-radius: 50%;
	}

	/* .slider::before {
        content: "";
        position: absolute;

        top: 0.7rem;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 50%;
        background: linear-gradient(to top, white, #cccccc);
        height: 25px;
        width: 25px;
    } */

	.switch-input:checked + .switch-label {
		background-color: #e6542b;
	}

	.switch-input:checked ~ .slider {
		margin-left: 38px;
	}

	.switch-input:checked ~ .switch-label::before {
		opacity: 0;
		right: -1rem;
	}

	.switch-input:checked ~ .switch-label::after {
		opacity: 1;
		left: 0.8rem;
	}
`;
